export default {

    colors: {

      // =========================================================
      // Tokens legados (posicionais) — mantidos para as telas que
      // ainda nao foram migradas. Ver DESIGN.md > "Mapeamento".
      // =========================================================

      primaryBackground: '#030714',
      primaryBackgroundRGB: '3,7,20',
  
      secondaryBackground: '#131f38',
      secondaryBackgroundRGB: '19,31,56',
  
      tertiaryBackground: '#21314b',
      tertiaryBackgroundRGB: '33,49,75',
  
      secondaryContrast: '#FFAE00',
      secondaryContrastRGB: '255,174,0',
  
      primaryContrast: '#1bb8ff',
      primaryContrastRGB: '27, 184, 255',
  
      secondaryText: '#c7f4ff',
      secondaryTextRGB: '199, 244, 255',
  
      tertiaryContrast: '#FD3636',
      tertiaryContrastRGB: '253, 54, 54',
  
      disableText: '#676B7C',
      disableTextRGB: '103, 107, 124',
  
      primaryText: '#FFFFFF',
      primaryTextRGB: '255,255,255',
  
      shadow: '#000000',
      shadowRGB: '0,0,0',
  
  
      facebookButton: '#3B5998',
      googleButton: '#DA4D39',

      // =========================================================
      // Tokens semanticos — DESIGN.md > "Paleta Modo Claro (padrao)"
      // VALORES EM PARIDADE COM O BEUDDY (tailwind.config.js), como a tela
      // ServiceList os usa: fundo = theme['surface-alt'], card = themeDark
      // ['surface-alt']. Superficie invertida -> DOIS conjuntos de texto/acento:
      //   text*/accent                 -> sobre o fundo bege
      //   surfaceText*/accentOnSurface -> dentro do card marrom
      // Nunca usar um sobre a superficie do outro.
      // =========================================================

      // --- pagina (beuddy: theme) ---
      background: '#E9DFC7',          // beuddy theme['surface-alt']
      backgroundRGB: '233,223,199',

      textPrimary: '#211C16',         // beuddy theme['text-primary']
      textPrimaryRGB: '33,28,22',

      textSecondary: '#7A6F5C',       // beuddy theme['text-secondary']
      textSecondaryRGB: '122,111,92',

      accent: '#9A7A3D',              // beuddy theme.accent
      accentRGB: '154,122,61',

      // Borda de nivel pagina. ATENCAO: 1.04:1 contra o bege — inutilizavel
      // como contorno de input. Ver DESIGN.md > Contraste.
      border: '#E3DBC9',              // beuddy theme.border
      borderRGB: '227,219,201',

      // ADICAO DO WEB — nao existe no beuddy. Contorno de campo sobre o
      // bege a 3.39:1 (>= 3:1 da WCAG 1.4.11), que `border` nao alcanca.
      borderField: '#857556',
      borderFieldRGB: '133,117,86',

      // --- card / superficies escuras (beuddy: themeDark) ---
      surface: '#2C271F',             // beuddy themeDark['surface-alt']
      surfaceRGB: '44,39,31',

      surfaceAlt: '#38332B',          // beuddy themeDark['surface-raised']
      surfaceAltRGB: '56,51,43',

      // ADICAO DO WEB — nao existe no beuddy. Divisor sobre superficie
      // escura a 2.34:1. Os tokens de borda do themeDark do beuddy ficam
      // todos entre 1.07 e 1.20:1 contra `surface`, invisiveis como linha.
      surfaceDivider: '#6A5E49',
      surfaceDividerRGB: '106,94,73',

      borderSubtle: '#3A342B',        // beuddy themeDark['border-subtle']
      borderSubtleRGB: '58,52,43',

      surfaceText: '#F5F1EA',         // beuddy themeDark['text-primary']
      surfaceTextRGB: '245,241,234',

      surfaceTextSecondary: '#9A8F7C',// beuddy themeDark['text-secondary']
      surfaceTextSecondaryRGB: '154,143,124',

      accentOnSurface: '#C9A15C',     // beuddy themeDark.accent
      accentOnSurfaceRGB: '201,161,92',

      // --- status (badges vivem dentro dos cards) ---
      accentBg: '#332A19',
      accentBgRGB: '51,42,25',

      success: '#8CA085',
      successRGB: '140,160,133',

      successBg: '#232B1F',
      successBgRGB: '35,43,31',

      warning: '#BD7148',
      warningRGB: '189,113,72',

      warningBg: '#332419',
      warningBgRGB: '51,36,25',

      overlay: '#15120E',             // beuddy themeDark.background
      overlayRGB: '21,18,14',
  
    }
  }
